// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"fbf81fb4","239":"775d4510"}[chunkId] + ".chunk.js";
};